module.exports = __webpack_public_path__ + "img/groups-1.7f5b2f47.svg";